import {
  ButtonFlavor, ButtonSize, ButtonType, ExButton, ExDialog, ExInput,
} from '@boomi/exosphere';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import apiService from '../../pages/BoomiAI/api-service';
import '../../pages/BoomiAI/BoomiAI.scss';

export default function AddLinkDialog(props: {
  updateProcessId: any,
  linkInputRef: any,
  inputRef: any,
  showAddLinkDialog: boolean,
  setShowAddLinkDialog: React.Dispatch<React.SetStateAction<boolean>>,
}) {
  const [linkUrl, setLinkUrl] = useState('');
  const [isError, setIsError] = useState(false);
  const [t] = useTranslation('common');
  const {
    updateProcessId,
    linkInputRef,
    inputRef,
    showAddLinkDialog,
    setShowAddLinkDialog,
  } = props;

  const closeLinkDialog = () => {
    setShowAddLinkDialog(false);
    document.body.style.overflow = 'unset';
    inputRef.current.focus();
  };

  const addLinkApi = () => {
    apiService.isValidUrl(linkUrl, 'process')
      .then((response: any) => {
        if (response.success) {
          closeLinkDialog();
          updateProcessId(response.results);
        } else if (!response.success) {
          setIsError(true);
        }
      })
      .catch((error: any) => error);
  };
  return (
    <div>
      <ExDialog
        className="add-link-dialog"
        open
        hideClose={false}
        staticBackdrop
        dialogTitle={t('add_link')}
        onCancel={closeLinkDialog}
        hideLeadingIcon
      >
        <p className="add-link-paragraph">
          {t('add_link_paragraph')}
        </p>
        <ExInput
          type="text"
          className="add-link-input"
          value={linkUrl}
          onInput={(e: any) => {
            setLinkUrl(e.target.value);
          }}
          error-msg={t('process_links_only')}
          invalid={isError}
          ref={linkInputRef}
          autoFocus={showAddLinkDialog}
        />
        <ExButton
          slot="footer"
          flavor={ButtonFlavor.BASE}
          type={ButtonType.TERTIARY}
          size={ButtonSize.LARGE}
          onClick={closeLinkDialog}
          className="add-link-footer-btn"
        >
          {t('cancel_btn')}
        </ExButton>
        <ExButton
          slot="footer"
          flavor={ButtonFlavor.BASE}
          type={ButtonType.PRIMARY}
          size={ButtonSize.LARGE}
          onClick={addLinkApi}
          className="add-link-footer-btn"
        >
          {t('add_btn')}
        </ExButton>
      </ExDialog>
    </div>
  );
}
